import React from "react";
import Table from "semantic-ui-react/dist/commonjs/collections/Table";
import Checkbox from "semantic-ui-react/dist/commonjs/modules/Checkbox";
import Dropdown from "semantic-ui-react/dist/commonjs/modules/Dropdown";

import masterData from "../../lib/masterData";
import api from "../../lib/api";
import { isBetsukanriInHokkaido } from "../../lib/isBetsukanriInHokkaido"
import classnames from "classnames";
import { modal } from "../../common/modal";
import { applyRoom } from "../area/util";
import { openReservation, openContactSelector, openContact, getPhoneNumber } from "../../common/callUtil"
import { callable } from "../../common/userAgent";
import { Link } from "../../lib/Link";

export default function roomListImplTable(params) {
  let state = {};
  const { rooms, prefSlug, asset, type, isNoVacancy } = params;

  const rooms1 = rooms && rooms.length > 0 && rooms.filter(x => x.vacant === masterData.vacant.AVAILABLE);
  const roomsAki1 = rooms && rooms.length > 0 && rooms.filter(x => x.vacant === masterData.vacant.AVAILABLE && 0.1 <=  x.extent && x.extent <= 1);
  const roomsAki2 = rooms && rooms.length > 0 && rooms.filter(x => x.vacant === masterData.vacant.AVAILABLE && 1.1 <=  x.extent && x.extent <= 3);
  const roomsAki3 = rooms && rooms.length > 0 && rooms.filter(x => x.vacant === masterData.vacant.AVAILABLE && 3.1 <=  x.extent && x.extent <= 5);
  const roomsAki4 = rooms && rooms.length > 0 && rooms.filter(x => x.vacant === masterData.vacant.AVAILABLE && 5.1 <=  x.extent);
  const roomsAkiContainer1 = rooms && rooms.length > 0 && rooms.filter(x => x.vacant === masterData.vacant.AVAILABLE && 0.1 <=  x.extent && x.extent <= 0.8);
  const roomsAkiContainer2 = rooms && rooms.length > 0 && rooms.filter(x => x.vacant === masterData.vacant.AVAILABLE && 0.9 <=  x.extent && x.extent <= 1.2);
  const roomsAkiContainer3 = rooms && rooms.length > 0 && rooms.filter(x => x.vacant === masterData.vacant.AVAILABLE && 1.3 <=  x.extent && x.extent <= 1.5);
  const roomsAkiContainer4 = rooms && rooms.length > 0 && rooms.filter(x => x.vacant === masterData.vacant.AVAILABLE && 1.6 <=  x.extent && x.extent <= 2.0);
  const roomsAkiContainer5 = rooms && rooms.length > 0 && rooms.filter(x => x.vacant === masterData.vacant.AVAILABLE && 2.1 <=  x.extent && x.extent <= 3.0);
  const roomsAkiContainer6 = rooms && rooms.length > 0 && rooms.filter(x => x.vacant === masterData.vacant.AVAILABLE && 3.1 <=  x.extent && x.extent <= 4.0);
  const roomsAkiContainer7 = rooms && rooms.length > 0 && rooms.filter(x => x.vacant === masterData.vacant.AVAILABLE && 4.1 <=  x.extent && x.extent <= 5.5);
  const roomsAkiContainer8 = rooms && rooms.length > 0 && rooms.filter(x => x.vacant === masterData.vacant.AVAILABLE && 5.6 <=  x.extent && x.extent <= 6.0);
  const roomsAkiContainer9 = rooms && rooms.length > 0 && rooms.filter(x => x.vacant === masterData.vacant.AVAILABLE && 6.1 <=  x.extent && x.extent <= 8.0);
  const roomsAkiContainer10 = rooms && rooms.length > 0 && rooms.filter(x => x.vacant === masterData.vacant.AVAILABLE && 8.1 <=  x.extent);
  const roomsElse = rooms && rooms.length > 0 && rooms.filter(x => x.vacant !== masterData.vacant.AVAILABLE &&
    (
        (x.riyouKikanEnd && x.riyouKikanEnd.replace(/-/g, "") > this.getAddDate(15).replace(/-/g, "")) || 
        (!x.riyouKikanEnd) ||
        (x.stockDateEnd)
    )
  );

  console.log("this.getAddDate(15)", this.getAddDate(15));
  console.log("asset", asset);
  console.log("rooms", rooms);
  console.log("rooms1", rooms1);
  console.log("roomsAki1", roomsAki1);
  console.log("roomsAki2", roomsAki2);
  console.log("roomsAki3", roomsAki3);
  console.log("roomsAki4", roomsAki4);
  console.log("roomsAkiContainer1", roomsAkiContainer1);
  console.log("roomsAkiContainer2", roomsAkiContainer2);
  console.log("roomsAkiContainer3", roomsAkiContainer3);
  console.log("roomsAkiContainer4", roomsAkiContainer4);
  console.log("roomsAkiContainer5", roomsAkiContainer5);
  console.log("roomsAkiContainer6", roomsAkiContainer6);
  console.log("roomsAkiContainer7", roomsAkiContainer7);
  console.log("roomsAkiContainer8", roomsAkiContainer8);
  console.log("roomsAkiContainer9", roomsAkiContainer9);
  console.log("roomsAkiContainer10", roomsAkiContainer10);
  console.log("roomsElse", roomsElse);
  console.log("isNoVacancy", isNoVacancy);
  console.log("this.state.condition.vacant", this.state.condition.vacant);

  const roomLabel = (room) => {
    if (room.flTxt) {
      if ((room.flTxt == '（ﾗｯｸ付）') && (room.opimages.length != 0)) {
        const img = [];
        room.opimages.map((opimage) => {
          img.push(api.roomOpImageUrl(asset.assetId, room.roomId, opimage));
        })
      
        return (         
          <span className="attentionRoom" onClick={() => modal.openModal("modal_roomimage", { imageUrl : img})}>{room.flTxt.replace(/[（）]/g, '')}</span>        
        );       
      } else {
        return (
          <span className="attentionRoom">{room.flTxt.replace(/[（）]/g, '')}</span>
        );
      }
    } else if (room.productTypeTxt) {
      return (
        <span className="attentionRoom">{room.productTypeTxt.replace(/[（）]/g, '')}</span>
      );
    } else {
      return null;
    }
  }

  const roomTable = (rooms, visible, visibleFooter) => {
    if (visible) {
      return (
        <span>
          <Table striped unstackable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell onClick={() => { }}>号室(階数)</Table.HeaderCell>
                <Table.HeaderCell onClick={() => { }}>空き状況</Table.HeaderCell>
                <Table.HeaderCell className="responder" onClick={() => this.toggleSort('extent')}>
                  広さ(帖)<span className={this.getSortIcon('extent')}></span>
                </Table.HeaderCell>
                <Table.HeaderCell className="responder" onClick={() => this.toggleSort('volume')}>
                  寸法　幅・奥行き・高さ(cm)<span className={this.getSortIcon('volume')}></span>
                </Table.HeaderCell>
                <Table.HeaderCell className="responder" onClick={() => this.toggleSort('price')}>
                  月額使用料<span className={this.getSortIcon('price')}></span>
                </Table.HeaderCell>
                {asset.warrantySimulation && <Table.HeaderCell onClick={() => { }}>月額管理費</Table.HeaderCell>}
                {(!isBetsukanriInHokkaido(asset) && asset.warrantySimulation) && <Table.HeaderCell onClick={() => { }}>安心保証パック</Table.HeaderCell>}

              </Table.Row>
            </Table.Header>

            <Table.Body>
              {rooms &&
                rooms.map((room, index) => {
                  return (
                    <Table.Row key={index}>
                      <Table.Cell>
                        <div className={classnames("room_no link", (room.flTxt || room.productTypeTxt) && 'fltxt')}>
                          {roomLabel(room)}
                          <span className="roomName">{room.roomName}({room.floor}
                          階)</span>
                          {(() => {
                            if (asset.floorplan) {
                              return (<div
                                onClick={() => this.openMadori(room)}
                                className="s_btn layout"
                              />)
                            } else {
                              return (<div className="s_btn layout disabled" />)
                            }
                          })()}
                        </div>
                      </Table.Cell>
                      <Table.Cell>
                        {(() => {
                          if (room.vacant === masterData.vacant.AVAILABLE) {
                            return (
                              <div className="oval">
                                <div
                                  onClick={() => {
                                    applyRoom(room, asset, type, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                                  }}
                                  className="s_btn request"
                                />
                                {!asset.disableEstimation && <div
                                  onClick={() =>
                                    modal.openModal("modal_estimate", {
                                      room,
                                      asset,
                                    })
                                  }
                                  className="s_btn estimate"
                                />}
                              </div>
                            );
                          } else if (room.vacant === masterData.vacant.CONTACT) {
                            return (
                              <div className="triangle">
                                {room.riyouKikanEnd && <div
                                  onClick={() => { openReservation({ asset, room, eventTrackingId: 'tel_action_room_list' }) }}
                                  className="s_btn inquiry"
                                >
                                  お問い合わせ<br />
                                  {room.riyouKikanEnd.replace(/-/g, "/") + " 空き予定"}
                                </div>}
                                {!room.riyouKikanEnd && <div
                                  onClick={() => { openContactSelector({ asset, room, eventTrackingId: 'tel_action_room_list' }) }}
                                  className="s_btn inquiry"
                                >
                                  お問い合わせ
                                </div>}
                                {(!asset.disableEstimation && !isBetsukanriInHokkaido(asset)) && <div
                                  onClick={() =>
                                    modal.openModal("modal_estimate", {
                                      room,
                                      asset,
                                    })
                                  }
                                  className="s_btn estimate"
                                />}
                              </div>
                            );
                          } else {
                            return (
                              <div className="cross">
                                <div className="s_btn request" />
                                {!asset.disableEstimation && <div
                                  onClick={() =>
                                    modal.openModal("modal_estimate", {
                                      room,
                                      asset,
                                    })
                                  }
                                  className="s_btn estimate"
                                />}
                              </div>
                            );
                          }
                        })()}
                      </Table.Cell>
                      <Table.Cell>
                        <div className="extent">
                          {room.extent}
                          {(() => {
                            if (asset.premium === 1 && !(4 < room.extent && room.extent < 7)) {
                              return (
                                <div className="s_btn play" onClick={() => modal.openModal("modal_video", this.getVideoUrl(room.extent))} />
                              );
                            }
                          })()}
                        </div>
                      </Table.Cell>
                      <Table.Cell>
                        <div className="size">
                          {room.width}×{room.depth}×{room.height}
                        </div>
                      </Table.Cell>
                      <Table.Cell>
                        {(() => {
                          if (room.campaignPrice && (room.vacant === 0 || room.vacant === 3)) {
                            return (
                              <div className="price campain">
                                <div>
                                  <div className="price_old">
                                    {room.price && room.price.toLocaleString()}
                                  </div>
                                  <div className="price_new">
                                    {room.campaignPrice && room.campaignPrice.toLocaleString()}
                                  </div>
                                </div>
                              </div>
                            );
                          } else {
                            return <div className="price">{room.price && room.price.toLocaleString()}</div>;
                          }
                        })()}
                      </Table.Cell>
                      {asset.warrantySimulation &&
                        <Table.Cell>
                          <div className="price_manage">
                            {room.managementFee && room.managementFee.toLocaleString()}
                          </div>
                        </Table.Cell>
                      }
                      {(!isBetsukanriInHokkaido(asset) && asset.warrantySimulation) &&
                      <Table.Cell>
                        <div>
                          <div className="price_manage">
                            {room.anshinpack && room.anshinpack.toLocaleString()}                     
                          </div>
                          &nbsp;or&nbsp;
                          <div className="price_manage">
                            {room.anshinpackplus && room.anshinpackplus.toLocaleString()}                     
                          </div>
                        </div>
                      </Table.Cell>
                      }
                    </Table.Row>
                  );
                })}
            </Table.Body>
          </Table>
          {visibleFooter && asset.webDiscount && <div className="data_footer">
            <div>
              <div className="infomation" style={{ "white-space": "pre-wrap" }}>
                {asset.webDiscount.text2}
              </div>
            </div>
          </div>}
        </span>
      )
    }
  }

  const jouTable = (asset, roomsAki, visible, index, headerFlg) => {
    return (
      <div className="outline">
        <table>
          {headerFlg && <tr>
            <th className="open"></th>
            <th className="outlineheader">タイプ</th>
            <th className="outlineheader">月額使用料</th>
            {asset.warrantySimulation && <th className="outlineheader">月額管理費</th>}
            {(!isBetsukanriInHokkaido(asset) && asset.warrantySimulation) && <th className="outlineheader">安心保証パック</th>}
          </tr>}
          <tr>
            <td className="open">
              <div className={visible ? 'icon12' : 'icon11'} onClick={() => this.toggleAki(visible, index)}>
                <div className="btn_plus">
                  <span>{visible ? '▶' : '▼'}詳細を{visible ? '隠す' : '表示'}</span>
                </div>
              </div>
            </td>
            <td colspan="4">
              <div className={visible ? 'icon22' : 'icon21'} onClick={() => this.toggleAki(visible, index)}>
                <div className="btn_plus">
                  <table >
                    <tr>
                      {Math.min.apply(null,roomsAki.map(function(o){return o.extent})) === Math.max.apply(null,roomsAki.map(function(o){return o.extent})) && <th className="outlinedata">
                        {Math.min.apply(null,roomsAki.map(function(o){return o.extent}))}帖
                      </th>}
                      {Math.min.apply(null,roomsAki.map(function(o){return o.extent})) !== Math.max.apply(null,roomsAki.map(function(o){return o.extent})) && <th className="outlinedata">
                        {Math.min.apply(null,roomsAki.map(function(o){return o.extent}))} ～ {Math.max.apply(null,roomsAki.map(function(o){return o.extent}))}帖
                      </th>}
                      <th className="outlinedata">
                        {(Math.min.apply(null,roomsAki.map(function(o){return o.campaignPrice})) > 0 ?
                          Math.min.apply(null,roomsAki.map(function(o){return o.campaignPrice})) :
                          Math.min.apply(null,roomsAki.map(function(o){return o.price}))).toLocaleString()}円～
                      </th>
                      {asset.warrantySimulation && <th className="outlinedata">
                        {Math.max.apply(null,roomsAki.map(function(o){return o.managementFee})).toLocaleString()}円
                      </th>}
                      {(!isBetsukanriInHokkaido(asset) && asset.warrantySimulation) && <th className="outlinedata">
                        {Math.min.apply(null,roomsAki.map(function(o){return o.anshinpack})).toLocaleString()}円 or&nbsp; 
                        {Math.min.apply(null,roomsAki.map(function(o){return o.anshinpackplus})).toLocaleString()}円
                      </th>}
                    </tr>
                  </table >
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    )
  }

  const contactType = masterData.contactType.bySlug["hokkaido2"];

  return (
    <div className="room_list">
      <div className="title"><h3>料金表</h3></div>
      <div className="data_header">
        <div
          className={classnames("item link", {
            active: this.state.floor == null,
          })}
          onClick={() => {
            this.selectFloor(null);
          }}
        >
          全ての階
        </div>
        {asset.floors &&
          asset.floors.map(({ floorId }) => (
            <div
              className={classnames("item link", {
                active: this.state.floor === floorId,
              })}
              key={floorId}
              onClick={() => {
                this.selectFloor(floorId);
              }}
            >
              {floorId}階
            </div>
          ))}
      </div>
      <div className="data_content">
        <div className="data_filter">
          <div>絞り込み</div>
          <div className="collection">
            {/*
            <div className="item extent">
              <Dropdown
                value={this.state.condition.extentKey}
                placeholder="広さ"
                options={masterData.extent.list}
                onChange={(event, element) => {
                  this.updateCondition({ extentKey: element.value });
                }}
              />
            </div>
            */}
            <div className="item price">
              <Dropdown
                value={this.state.condition.priceKey}
                placeholder="金額"
                options={masterData.price.list}
                onChange={(event, element) => {
                  this.updateCondition({ priceKey: element.value });
                }}
              />
            </div>
          </div>
        </div>
        {!isBetsukanriInHokkaido(asset) && <div className="data_table room_table">
          {(asset.assetType === 'bikeonly' || asset.bike === 1) && <div>
            {!isNoVacancy && rooms1 && rooms1.length > 0 && roomTable(rooms1, true, false)}
          </div>}
          {(asset.assetType == 'okunai' && asset.assetType !== 'bikeonly' && asset.bike !== 1) && <div>
            {!isNoVacancy && ((roomsAki1 && roomsAki1.length > 0) || (roomsAki2 && roomsAki2.length > 0) ||
              (roomsAki3 && roomsAki3.length > 0) || (roomsAki4 && roomsAki4.length > 0)) && <div className="space" />}
            {!isNoVacancy && roomsAki1 && roomsAki1.length > 0 && jouTable(asset, roomsAki1, this.state.aki1Visible, 1, true)}
            {!isNoVacancy && roomsAki1 && roomsAki1.length > 0 && roomTable(roomsAki1, this.state.aki1Visible, false)}
            {!isNoVacancy && roomsAki2 && roomsAki2.length > 0 && jouTable(asset, roomsAki2, this.state.aki2Visible, 2, (roomsAki1 && roomsAki1.length == 0))}
            {!isNoVacancy && roomsAki2 && roomsAki2.length > 0 && roomTable(roomsAki2, this.state.aki2Visible, false)}
            {!isNoVacancy && roomsAki3 && roomsAki3.length > 0 && jouTable(asset, roomsAki3, this.state.aki3Visible, 3, (roomsAki1 && roomsAki1.length == 0 && roomsAki2 && roomsAki2.length == 0))}
            {!isNoVacancy && roomsAki3 && roomsAki3.length > 0 && roomTable(roomsAki3, this.state.aki3Visible, false)}
            {!isNoVacancy && roomsAki4 && roomsAki4.length > 0 && jouTable(asset, roomsAki4, this.state.aki4Visible, 4, (roomsAki1 && roomsAki1.length == 0 && roomsAki2 && roomsAki2.length == 0 && roomsAki3 && roomsAki3.length == 0))}
            {!isNoVacancy && roomsAki4 && roomsAki4.length > 0 && roomTable(roomsAki4, this.state.aki4Visible, false)}
            {!isNoVacancy && ((roomsAki1 && roomsAki1.length > 0) || (roomsAki2 && roomsAki2.length > 0) ||
              (roomsAki3 && roomsAki3.length > 0) || (roomsAki4 && roomsAki4.length > 0)) && <div className="space" />}
          </div>}
          {(asset.assetType == 'okugai' && asset.assetType !== 'bikeonly' && asset.bike !== 1) && <div>
            {!isNoVacancy && ((roomsAkiContainer1 && roomsAkiContainer1.length > 0) || (roomsAkiContainer2 && roomsAkiContainer2.length > 0) ||
              (roomsAkiContainer3 && roomsAkiContainer3.length > 0) || (roomsAkiContainer4 && roomsAkiContainer4.length > 0) ||
              (roomsAkiContainer5 && roomsAkiContainer5.length > 0) || (roomsAkiContainer6 && roomsAkiContainer6.length > 0) ||
              (roomsAkiContainer7 && roomsAkiContainer7.length > 0) || (roomsAkiContainer8 && roomsAkiContainer8.length > 0) ||
              (roomsAkiContainer9 && roomsAkiContainer9.length > 0) || (roomsAkiContainer10 && roomsAkiContainer10.length > 0)) && <div className="space" />}
            {!isNoVacancy && roomsAkiContainer1 && roomsAkiContainer1.length > 0 && jouTable(asset, roomsAkiContainer1, this.state.akiContainer1Visible, 11, true)}
            {!isNoVacancy && roomsAkiContainer1 && roomsAkiContainer1.length > 0 && roomTable(roomsAkiContainer1, this.state.akiContainer1Visible, false)}
            {!isNoVacancy && roomsAkiContainer2 && roomsAkiContainer2.length > 0 && jouTable(asset, roomsAkiContainer2, this.state.akiContainer2Visible, 12, (roomsAkiContainer1 && roomsAkiContainer1.length == 0))}
            {!isNoVacancy && roomsAkiContainer2 && roomsAkiContainer2.length > 0 && roomTable(roomsAkiContainer2, this.state.akiContainer2Visible, false)}
            {!isNoVacancy && roomsAkiContainer3 && roomsAkiContainer3.length > 0 && jouTable(asset, roomsAkiContainer3, this.state.akiContainer3Visible, 13, (roomsAkiContainer1 && roomsAkiContainer1.length == 0 && roomsAkiContainer2 && roomsAkiContainer2.length == 0))}
            {!isNoVacancy && roomsAkiContainer3 && roomsAkiContainer3.length > 0 && roomTable(roomsAkiContainer3, this.state.akiContainer3Visible, false)}
            {!isNoVacancy && roomsAkiContainer4 && roomsAkiContainer4.length > 0 && jouTable(asset, roomsAkiContainer4, this.state.akiContainer4Visible, 14, (roomsAkiContainer1 && roomsAkiContainer1.length == 0 && roomsAkiContainer2 && roomsAkiContainer2.length == 0 && roomsAkiContainer3 && roomsAkiContainer3.length == 0))}
            {!isNoVacancy && roomsAkiContainer4 && roomsAkiContainer4.length > 0 && roomTable(roomsAkiContainer4, this.state.akiContainer4Visible, false)}
            {!isNoVacancy && roomsAkiContainer5 && roomsAkiContainer5.length > 0 && jouTable(asset, roomsAkiContainer5, this.state.akiContainer5Visible, 15, (roomsAkiContainer1 && roomsAkiContainer1.length == 0 && roomsAkiContainer2 && roomsAkiContainer2.length == 0 && roomsAkiContainer3 && roomsAkiContainer3.length == 0 && roomsAkiContainer4 && roomsAkiContainer4.length == 0))}
            {!isNoVacancy && roomsAkiContainer5 && roomsAkiContainer5.length > 0 && roomTable(roomsAkiContainer5, this.state.akiContainer5Visible, false)}
            {!isNoVacancy && roomsAkiContainer6 && roomsAkiContainer6.length > 0 && jouTable(asset, roomsAkiContainer6, this.state.akiContainer6Visible, 16, (roomsAkiContainer1 && roomsAkiContainer1.length == 0 && roomsAkiContainer2 && roomsAkiContainer2.length == 0 && roomsAkiContainer3 && roomsAkiContainer3.length == 0 && roomsAkiContainer4 && roomsAkiContainer4.length == 0 && roomsAkiContainer5 && roomsAkiContainer5.length == 0))}
            {!isNoVacancy && roomsAkiContainer6 && roomsAkiContainer6.length > 0 && roomTable(roomsAkiContainer6, this.state.akiContainer6Visible, false)}
            {!isNoVacancy && roomsAkiContainer7 && roomsAkiContainer7.length > 0 && jouTable(asset, roomsAkiContainer7, this.state.akiContainer7Visible, 17, (roomsAkiContainer1 && roomsAkiContainer1.length == 0 && roomsAkiContainer2 && roomsAkiContainer2.length == 0 && roomsAkiContainer3 && roomsAkiContainer3.length == 0 && roomsAkiContainer4 && roomsAkiContainer4.length == 0 && roomsAkiContainer5 && roomsAkiContainer5.length == 0 && roomsAkiContainer6 && roomsAkiContainer6.length == 0))}
            {!isNoVacancy && roomsAkiContainer7 && roomsAkiContainer7.length > 0 && roomTable(roomsAkiContainer7, this.state.akiContainer7Visible, false)}
            {!isNoVacancy && roomsAkiContainer8 && roomsAkiContainer8.length > 0 && jouTable(asset, roomsAkiContainer8, this.state.akiContainer8Visible, 18, (roomsAkiContainer1 && roomsAkiContainer1.length == 0 && roomsAkiContainer2 && roomsAkiContainer2.length == 0 && roomsAkiContainer3 && roomsAkiContainer3.length == 0 && roomsAkiContainer4 && roomsAkiContainer4.length == 0 && roomsAkiContainer5 && roomsAkiContainer5.length == 0 && roomsAkiContainer6 && roomsAkiContainer6.length == 0 && roomsAkiContainer7 && roomsAkiContainer7.length == 0))}
            {!isNoVacancy && roomsAkiContainer8 && roomsAkiContainer8.length > 0 && roomTable(roomsAkiContainer8, this.state.akiContainer8Visible, false)}
            {!isNoVacancy && roomsAkiContainer9 && roomsAkiContainer9.length > 0 && jouTable(asset, roomsAkiContainer9, this.state.akiContainer9Visible, 19, (roomsAkiContainer1 && roomsAkiContainer1.length == 0 && roomsAkiContainer2 && roomsAkiContainer2.length == 0 && roomsAkiContainer3 && roomsAkiContainer3.length == 0 && roomsAkiContainer4 && roomsAkiContainer4.length == 0 && roomsAkiContainer5 && roomsAkiContainer5.length == 0 && roomsAkiContainer6 && roomsAkiContainer6.length == 0 && roomsAkiContainer7 && roomsAkiContainer7.length == 0 && roomsAkiContainer8 && roomsAkiContainer8.length == 0))}
            {!isNoVacancy && roomsAkiContainer9 && roomsAkiContainer9.length > 0 && roomTable(roomsAkiContainer9, this.state.akiContainer9Visible, false)}
            {!isNoVacancy && roomsAkiContainer10 && roomsAkiContainer10.length > 0 && jouTable(asset, roomsAkiContainer10, this.state.akiContainer10Visible, 20, (roomsAkiContainer1 && roomsAkiContainer1.length == 0 && roomsAkiContainer2 && roomsAkiContainer2.length == 0 && roomsAkiContainer3 && roomsAkiContainer3.length == 0 && roomsAkiContainer4 && roomsAkiContainer4.length == 0 && roomsAkiContainer5 && roomsAkiContainer5.length == 0 && roomsAkiContainer6 && roomsAkiContainer6.length == 0 && roomsAkiContainer7 && roomsAkiContainer7.length == 0 && roomsAkiContainer8 && roomsAkiContainer8.length == 0 && roomsAkiContainer9 && roomsAkiContainer9.length == 0))}
            {!isNoVacancy && roomsAkiContainer10 && roomsAkiContainer10.length > 0 && roomTable(roomsAkiContainer10, this.state.akiContainer10Visible, false)}
            {!isNoVacancy && ((roomsAkiContainer1 && roomsAkiContainer1.length > 0) || (roomsAkiContainer2 && roomsAkiContainer2.length > 0) ||
              (roomsAkiContainer3 && roomsAkiContainer3.length > 0) || (roomsAkiContainer4 && roomsAkiContainer4.length > 0) ||
              (roomsAkiContainer5 && roomsAkiContainer5.length > 0) || (roomsAkiContainer6 && roomsAkiContainer6.length > 0) ||
              (roomsAkiContainer7 && roomsAkiContainer7.length > 0) || (roomsAkiContainer8 && roomsAkiContainer8.length > 0) ||
              (roomsAkiContainer9 && roomsAkiContainer9.length > 0) || (roomsAkiContainer10 && roomsAkiContainer10.length > 0)) && <div className="space" />}
          </div>}
          {!isNoVacancy && roomsElse && roomsElse.length > 0 && <div className="icon" onClick={() => this.toggleElse(this.state.elseVisible)}>
            <div className="btn_plus">
              <span>空き予定部屋を{this.state.elseVisible ? '隠す' : '表示'}</span>
              <i className={"fas " + (this.state.elseVisible ? 'fa-angle-double-up' : 'fa-angle-double-down')}></i>
            </div>
          </div>}
          {!isNoVacancy && roomsElse && roomsElse.length > 0 && roomTable(roomsElse, this.state.elseVisible, true)}
          {((isNoVacancy) || ((!roomsAki1 || roomsAki1.length === 0) && (!roomsAki2 || roomsAki2.length === 0) &&
            (!roomsAki3 || roomsAki3.length === 0) && (!roomsAki4 || roomsAki4.length === 0) && (!roomsElse || roomsElse.length === 0))) && <Table striped unstackable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell onClick={() => { }}>号室(階数)</Table.HeaderCell>
                <Table.HeaderCell onClick={() => { }}>空き状況</Table.HeaderCell>
                <Table.HeaderCell className="responder" onClick={() => this.toggleSort('extent')}>
                  広さ(帖)<span className={this.getSortIcon('extent')}></span>
                </Table.HeaderCell>
                <Table.HeaderCell className="responder" onClick={() => this.toggleSort('volume')}>
                  寸法　幅・奥行き・高さ(cm)<span className={this.getSortIcon('volume')}></span>
                </Table.HeaderCell>
                <Table.HeaderCell className="responder" onClick={() => this.toggleSort('price')}>
                  月額使用料<span className={this.getSortIcon('price')}></span>
                </Table.HeaderCell>
                {asset.warrantySimulation && <Table.HeaderCell onClick={() => { }}>月額管理費</Table.HeaderCell>}
                {(!isBetsukanriInHokkaido(asset) && asset.warrantySimulation) && <Table.HeaderCell onClick={() => { }}>安心保証パック</Table.HeaderCell>}
              </Table.Row>
            </Table.Header>

            <Table.Body>
            </Table.Body>
          </Table>}

          { !asset.isAssetReceived && <div className="recommended_points" style={{fontWeight: 'bold', textAlign: 'center', color: 'red'}}>
            部屋情報を取得中…
          </div>}
          {(asset.isAssetReceived && ((isNoVacancy) || ((!roomsAki1 || roomsAki1.length === 0) && (!roomsAki2 || roomsAki2.length === 0) &&
            (!roomsAki3 || roomsAki3.length === 0) && (!roomsAki4 || roomsAki4.length === 0) && (!roomsElse || roomsElse.length === 0)))) && <div className="noVacancy">
            {(isNoVacancy && !isBetsukanriInHokkaido(asset)) && <div>
              申し訳ございません。ただいま満室となっております。
              　<br />他の物件をお探しください。<br />
            </div>}
            { (isNoVacancy && isBetsukanriInHokkaido(asset)) && <div>
              物件の空き状況については、{contactType.phoneNumber}　までお電話ください。
            </div>}
            {(((!isNoVacancy) || ((!roomsAki1 || roomsAki1.length === 0) && (!roomsAki2 || roomsAki2.length === 0) &&
              (!roomsAki3 || roomsAki3.length === 0) && (!roomsAki4 || roomsAki4.length === 0) && (!roomsElse || roomsElse.length === 0))) && !isBetsukanriInHokkaido(asset)) && <div>
              該当する部屋はありません
              <div>
                条件を変えて検索してください
              </div>
            </div>}
          </div>}
        </div>}
        {isBetsukanriInHokkaido(asset) && <div className="data_table room_table">
          {rooms && rooms.length > 0 && roomTable(rooms, true, false)}
        </div>}
      </div>
      {asset.webDiscount && (
        <div className="data_footer">
          <div className="data_footer_inner">
            <div className="infomation" style={{ "white-space": "pre-wrap" }}>
              {asset.webDiscount.text}
              <br />
              {!isBetsukanriInHokkaido(asset) && <div>
                ※安心保証パックについては<Link className="link" to="/anshinpack">こちら</Link>
              </div>}
              <div className="infomation" style={{ "white-space": "pre-wrap" }}>
                {asset.webDiscount.text3}
              </div>
              {asset.webDiscount.text4}
            </div>
          </div>
        </div>
      )}
      {asset.obj_information && (
      <div className="data_content">
        <div className="description">
          <div className="title">物件詳細</div>
          <div className="block">
            <div className="item">{asset.obj_information}</div>
          </div>
        </div>
      </div>
      )}
    </div>
  );

}



// WEBPACK FOOTER //
// ./pages/detail/roomListImplTable.jsx